// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__op0NQ","active":"Tag_active__8sO-M","inactive":"Tag_inactive__o02g6"};